import { Box, Tooltip, Typography, useTheme } from '@mui/material'
import type { FC } from 'react'

type Props = {
  label: string
  tooltip: string
  x: number
  y: number
  width: number
  height: number
  color: 'error' | 'primary'
  onClick?: (event: React.MouseEvent) => void
}

/** ラベル画像上に表示されるBBox */
export const BBox: FC<Props> = ({
  label,
  tooltip,
  x,
  y,
  width,
  height,
  color,
  onClick,
}) => {
  const theme = useTheme()
  const palette = theme.palette[color]

  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <Box
        onClick={
          onClick
            ? event => {
                event.stopPropagation()
                onClick(event)
              }
            : undefined
        }
        sx={{
          position: 'absolute',
          border: `2px solid ${palette.main}`,
          left: `${x * 100}%`,
          top: `${y * 100}%`,
          width: `${width * 100}%`,
          height: `${height * 100}%`,
          cursor: onClick ? 'pointer' : 'default',
          zIndex: 2,
          '&:hover': {
            border: `2px solid ${palette.dark}`,
            backgroundColor: `${palette.main}1A`,
          },
        }}
      >
        <Typography
          sx={{
            position: 'absolute',
            top: '-20px',
            left: '0',
            backgroundColor: `${color}.main`,
            padding: '2px 4px',
            fontSize: 12,
            borderRadius: '4px',
            textWrap: 'nowrap',
            color: 'white',
          }}
        >
          {label}
        </Typography>
      </Box>
    </Tooltip>
  )
}
